import React from 'react';
import { withRouteData } from 'react-static';
import { Link } from '@reach/router';
import convert from 'htmr';
import Helmet from 'react-helmet';
import moment from 'moment';

import Navigation from '../components/WaveNavigation/';
// import Instagram from '../components/Instagram/';

export default withRouteData(({ post, posts }) => (
  <div>
    <Helmet
      title={`Fire Island Ferries | ${post.title}`}
      meta={[
        { name: 'description', content: `${post.excerpt}` },
        {
          name: 'keywords',
          content: 'Fire Island Ferries, Water Taxi, notifications, updates',
        },
      ]}
    />
    {console.log(post)}
    <Navigation />
    <div className="container page">
      <div className="row">
        <div className="col-md-8">
          <div className="heading m-0">
            <h2>{post.tags.join(', ')}</h2>
            <h1>{post.title}</h1>
          </div>
          <div className="details">
            <span className="timestamp">
              <i className="far fa-calendar" />{' '}
              {moment(post.publishDate).format('MMMM D, YYYY')}
            </span>
          </div>
          {post && post.image && <img src={post.image} alt="Updates" />}
          {convert(post.html)}
        </div>
        <div className="col-md-4">
          <h2>
            <i className="fal fa-newspaper" /> Site Updates
          </h2>
          {posts &&
            posts.length &&
            posts.map(item => (
              <div className="update-list" key={item.slug}>
                <Link to={`/updates/${item.slug}`}>
                  {item.title}{' '}
                  <div className="posted">
                    <i className="far fa-calendar" />{' '}
                    {moment(item.publishDate).format('MMMM D, YYYY')}{' '}
                    <i className="far fa-tags" /> {item.tags.join(', ')}
                  </div>
                </Link>
              </div>
            ))}
          {/* <h2 className="mb-3"><i className="fab fa-instagram" /> Instagram Updates</h2> */}
          {/* <Instagram limit="1" /> */}
        </div>
      </div>
    </div>
  </div>
));
